/* eslint-disable */

import Vue from 'vue'
import App from './App'
import VueResource from 'vue-resource';
import router from './router'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import { store } from "./store";
import axios from "axios";
import 'material-design-icons-iconfont/dist/material-design-icons.css' // Ensure you are using css-loader
import '@mdi/font/css/materialdesignicons.css' // Ensure you are using css-loader
import '@fortawesome/fontawesome-free/css/all.css' // Ensure you are using css-loader
import 'font-awesome/css/font-awesome.min.css' // Ensure you are using css-loader
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { fas } from '@fortawesome/free-solid-svg-icons'
// import { faBars } from '@fortawesome/pro-light-svg-icons'
import { faVuejs } from '@fortawesome/free-brands-svg-icons'
import '@fortawesome/fontawesome-free/css/all.css'
import VueProgressBar from 'vue-progressbar'
import api from './utils/backend-api'
import CKEditor from '@ckeditor/ckeditor5-vue'

Vue.component('font-awesome-icon', FontAwesomeIcon)
library.add(faVuejs)
library.add(fas) // Include needed icons.

axios.defaults.baseURL = process.env.BASE_URL;
axios.defaults.headers.get['Accepts'] = 'application/json';
axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*';
axios.defaults.headers.common['Access-Control-Allow-Headers'] = 'Origin, X-Requested-With, Content-Type, Accept';


Vue.use(Vuetify, {
    theme: {

      primary: '#0051a0',
      dedf: '#002f6f',
      // primary: '#077FFF',
      secondary: '#424242',
      accent: '#82B1FF',
      error: '#FF5252',
      info: '#2196F3',
      success: '#4CAF50',
      warning: '#FFC107'
    },
    iconfont: 'fa'

});

const options = {
    color: '#2196f3',
    failedColor: '#874b4b',
    thickness: '5px',
    transition: {
        speed: '0.1s',
        opacity: '0.5s',
        termination: 400
    },
    autoRevert: true,
    location: 'top',
    inverse: false
}
Vue.use(Vuetify, {
  iconfont: 'md'
})
Vue.use(Vuetify, {
  iconfont: 'mdi'
})
Vue.use(Vuetify, {
  iconfont: 'fa'
})
Vue.use(Vuetify, {
  iconfont: 'fa4'
})
Vue.use(Vuetify, {
  iconfont: 'faSvg'
})
Vue.use( CKEditor )

Vue.use(VueProgressBar, options)
Vue.use(VueResource)
Vue.config.productionTip = false
window.Store = store
Vue.prototype.api = api
    /* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    store,
    axios,
    render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js